import React from 'react';
import { Box } from '@ublend-npm/aulaui-core';
import { INBOX_BEGINNING_CONVERSATION } from '../../../../../constants/texts';
import { Label } from './BeginningIndicator.styled';
import GroupAvatarIndicator from './GroupAvatarIndicator.container';

const BeginningIndicator = () => (
  <Box sx={{ pb: '2rem' }}>
    <GroupAvatarIndicator />
    <Label>{INBOX_BEGINNING_CONVERSATION} </Label>
  </Box>
);

export default BeginningIndicator;
